import MaterialIcon from '@material/react-material-icon';
import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import DistributionListMapping from './DistributionListMapping';
import { Button } from '@upmc/ims.component-library';
import { DeactivateAppDistributionList } from '../../../_api';
import AppDistributionListRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/AppDistributionListRequest';
import ApiErrors from '../../../components/NewApplication/ApiErrors';

const DistributionListDisplay = ({
	appDistributionLists,
	appID,
	readOnly,
	app,
	currentUser,
	requirementNumber,
	reload,
	apiErrors,
	setApiErrors,
}) => {
	const handleDelete = xref => {
		let request = new AppDistributionListRequest(app, currentUser, xref);
		request.RequirementNumber = requirementNumber;

		DeactivateAppDistributionList(request)
			.then(resp => {
				if (resp.error) {
					setApiErrors(resp.error);
				}
			})
			.then(x => reload());
	};

	const headers = [
		{
			Value: 'Action',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Distribution List Name',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'SQL Statement',
			props: { sort: null, onSortChange: null },
		},
	];

	const rows = appDistributionLists.map(xref => {
		return {
			Cells: {
				Action: {
					Value: (
						<>
							<Button
								onClick={e => handleDelete(xref)}
								startIcon={<MaterialIcon icon='delete' />}
								disabled={readOnly}
							>
								Delete
							</Button>
						</>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Distribution List Name': {
					Value: xref.DistributionListName,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},

				'SQL Statement': {
					Value: xref.SQLStatement,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: xref.DistributionListName,
		};
	});

	return (
		<div>
			<ApiErrors errors={apiErrors} />
			<DataTable rows={rows} headers={headers} />
			<DistributionListMapping
				appID={appID}
				readOnly={readOnly}
				app={app}
				currentUser={currentUser}
				requirementNumber={requirementNumber}
				reload={reload}
			/>
		</div>
	);
};

export default DistributionListDisplay;
